// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Modal SPOA — mismo lenguaje visual que Grabaciones / DownloadAdvanced
   Paleta: superficies #0a0a0a–#1a1a1a, bordes #2d2d2d / #374151, acento #a61b34
   ============================================================ */

.rspoa-modal {
  /* tokens locales (portal en body; no heredan .recordings-page) */
  --rspoa-bg: #111111;
  --rspoa-bg-elevated: #1a1a1a;
  --rspoa-bg-muted: #0a0a0a;
  --rspoa-border: #2d2d2d;
  --rspoa-border-subtle: #374151;
  --rspoa-text: #e5e7eb;
  --rspoa-text-muted: #9ca3af;
  --rspoa-accent: #a61b34;
  --rspoa-accent-deep: #8b1528;
  --rspoa-focus: #a61b34;
  --rspoa-input-bg: #252525;
  --rspoa-danger: #f87171;
  --rspoa-danger-bg: rgba(248, 113, 113, 0.08);
}

/* ---------- Overlay ---------- */
.rspoa-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

/* ---------- Modal shell ---------- */
.rspoa-modal {
  width: min(960px, 100%);
  max-height: min(92vh, 820px);
  display: flex;
  flex-direction: column;
  background: var(--rspoa-bg-elevated);
  border: 1px solid var(--rspoa-border);
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.55);
  overflow: hidden;
  color: var(--rspoa-text);
  font-family: inherit;
}

/* ---------- Header ---------- */
.rspoa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--rspoa-border);
  flex-shrink: 0;
  background: var(--rspoa-bg);
}

.rspoa-header__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--rspoa-text);
}

.rspoa-header__close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--rspoa-text-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.rspoa-header__close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--rspoa-text);
}

/* ---------- Search bar (Consultar view) ---------- */
.rspoa-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--rspoa-border);
  flex-shrink: 0;
  background: var(--rspoa-bg);
}

.rspoa-search__input {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid var(--rspoa-border-subtle);
  border-radius: 8px;
  font-size: 14px;
  color: var(--rspoa-text);
  background: var(--rspoa-input-bg);
  outline: none;
}

.rspoa-search__input:focus {
  border-color: var(--rspoa-focus);
}

.rspoa-search__input::placeholder {
  color: #6b7280;
}

.rspoa-search__icon {
  flex-shrink: 0;
  color: var(--rspoa-text-muted);
}

/* ---------- Body ---------- */
.rspoa-body {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* --- Consultar layout --- */
.rspoa-body--consult {
  display: grid;
  grid-template-columns: minmax(200px, 0.7fr) 1fr;
}

.rspoa-results {
  border-right: 1px solid var(--rspoa-border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--rspoa-bg);
}

.rspoa-panel-title {
  margin: 0;
  padding: 12px 16px 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--rspoa-text);
  flex-shrink: 0;
}

.rspoa-results__scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 4px 8px;
}

.rspoa-results__item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: var(--rspoa-text);
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid var(--rspoa-border);
  transition: background 0.1s;
}

.rspoa-results__item:hover {
  background: rgba(255, 255, 255, 0.04);
}

.rspoa-results__item--active {
  background: rgba(166, 27, 52, 0.18);
  font-weight: 600;
  color: #fff;
}

.rspoa-pruebas {
  display: flex;
  flex-direction: column;
  background: var(--rspoa-bg-muted);
  overflow: hidden;
}

.rspoa-pruebas__content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 16px 12px;
}

.rspoa-pruebas__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rspoa-prueba-card {
  padding: 10px 12px;
  background: var(--rspoa-bg-elevated);
  border: 1px solid var(--rspoa-border-subtle);
  border-radius: 8px;
}

.rspoa-prueba-card__info strong {
  font-size: 13px;
  color: var(--rspoa-text);
}

.rspoa-prueba-card__date {
  display: inline-block;
  margin-left: 10px;
  font-size: 11px;
  color: var(--rspoa-text-muted);
}

.rspoa-prueba-card__desc {
  margin: 4px 0 6px;
  font-size: 12px;
  color: var(--rspoa-text-muted);
  line-height: 1.4;
}

.rspoa-prueba-card__thumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.rspoa-prueba-card__thumb {
  width: 48px;
  height: 36px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--rspoa-border-subtle);
  background: var(--rspoa-input-bg);
}

.rspoa-prueba-card__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.rspoa-prueba-card__more {
  font-size: 11px;
  color: var(--rspoa-text-muted);
}

.rspoa-pruebas__actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.rspoa-placeholder-text {
  margin: 0;
  padding: 40px 20px;
  text-align: center;
  font-size: 13px;
  color: var(--rspoa-text-muted);
  line-height: 1.5;
}

.rspoa-muted-text {
  margin: 0;
  padding: 12px 16px;
  font-size: 13px;
  color: var(--rspoa-text-muted);
}

.rspoa-muted-text--small {
  font-size: 12px;
  padding: 8px 0;
}

/* --- Crear evidencia layout --- */
.rspoa-body--create {
  display: grid;
  grid-template-columns: 210px 1fr;
}

.rspoa-sidebar {
  border-right: 1px solid var(--rspoa-border);
  padding: 16px 14px;
  overflow-y: auto;
  background: var(--rspoa-bg);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rspoa-sidebar__spoa-label {
  font-size: 13px;
  color: var(--rspoa-text);
  line-height: 1.4;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--rspoa-border);
}

.rspoa-sidebar__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rspoa-sidebar__field label {
  font-size: 12px;
  color: var(--rspoa-text-muted);
  font-weight: 500;
}

.rspoa-sidebar__field input {
  padding: 8px 10px;
  border: 1px solid var(--rspoa-border-subtle);
  border-radius: 8px;
  font-size: 13px;
  color: var(--rspoa-text);
  background: var(--rspoa-input-bg);
  outline: none;
}

.rspoa-sidebar__field input:focus {
  border-color: var(--rspoa-focus);
}

.rspoa-sidebar__cameras {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
}

.rspoa-camera-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  color: var(--rspoa-text);
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s, color 0.15s;
}

.rspoa-camera-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.rspoa-camera-item--active {
  background: rgba(166, 27, 52, 0.35);
  color: #fff;
  box-shadow: inset 0 0 0 1px rgba(166, 27, 52, 0.5);
}

.rspoa-camera-item--active:hover {
  background: rgba(166, 27, 52, 0.42);
}

.rspoa-camera-item__name {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rspoa-camera-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--rspoa-accent);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.rspoa-camera-item--active .rspoa-camera-badge {
  background: rgba(255, 255, 255, 0.25);
}

/* --- Content (right panel in Crear view) --- */
.rspoa-content {
  padding: 16px 20px;
  overflow-y: auto;
  background: var(--rspoa-bg-muted);
}

.rspoa-section-title {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--rspoa-text);
}

.rspoa-error {
  margin: 0 0 12px;
  padding: 8px 12px;
  font-size: 12px;
  color: var(--rspoa-danger);
  background: var(--rspoa-danger-bg);
  border: 1px solid rgba(248, 113, 113, 0.25);
  border-radius: 8px;
}

.rspoa-site-box {
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--rspoa-border-subtle);
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 1.7;
  color: var(--rspoa-text-muted);
}

.rspoa-site-box__title {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--rspoa-text);
}

.rspoa-site-box p {
  margin: 0;
}

.rspoa-site-box strong {
  color: var(--rspoa-text);
}

.rspoa-form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.rspoa-field {
  margin-bottom: 16px;
}

.rspoa-field--grow {
  flex: 1 1;
  min-width: 0;
  margin-bottom: 0;
}

.rspoa-field > label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--rspoa-text-muted);
  margin-bottom: 6px;
}

.rspoa-field textarea,
.rspoa-field select,
.rspoa-field input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid var(--rspoa-border-subtle);
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  color: var(--rspoa-text);
  background: var(--rspoa-input-bg);
  outline: none;
  resize: vertical;
}

.rspoa-field textarea:focus,
.rspoa-field select:focus,
.rspoa-field input:focus {
  border-color: var(--rspoa-focus);
}

.rspoa-field select {
  appearance: auto;
  cursor: pointer;
}

.rspoa-field select option {
  background: var(--rspoa-bg-elevated);
  color: var(--rspoa-text);
}

/* --- Captures with per-photo descriptions --- */
.rspoa-captures-detail {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 16px;
}

.rspoa-capture-row {
  display: flex;
  gap: 14px;
  padding: 10px 12px;
  background: var(--rspoa-bg);
  border: 1px solid var(--rspoa-border-subtle);
  border-radius: 8px;
  align-items: flex-start;
}

.rspoa-capture-row__preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.rspoa-capture-row__num {
  font-size: 12px;
  font-weight: 700;
  color: var(--rspoa-text-muted);
}

.rspoa-capture-row__thumb {
  width: 110px;
  height: 78px;
  padding: 0;
  border: 2px solid var(--rspoa-accent);
  border-radius: 8px;
  overflow: hidden;
  background: var(--rspoa-input-bg);
  cursor: zoom-in;
}

.rspoa-capture-row__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.rspoa-capture-row__time {
  font-size: 10px;
  color: var(--rspoa-text-muted);
  text-align: center;
}

.rspoa-capture-row__desc {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rspoa-capture-row__desc label {
  font-size: 12px;
  font-weight: 500;
  color: var(--rspoa-text-muted);
}

.rspoa-capture-row__desc textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid var(--rspoa-border-subtle);
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  color: var(--rspoa-text);
  background: var(--rspoa-input-bg);
  outline: none;
  resize: vertical;
  min-height: 56px;
}

.rspoa-capture-row__desc textarea:focus {
  border-color: var(--rspoa-focus);
}

.rspoa-capture__fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 10px;
  color: var(--rspoa-text-muted);
  text-align: center;
  padding: 4px;
  box-sizing: border-box;
}

/* ---------- Footer ---------- */
.rspoa-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--rspoa-border);
  flex-shrink: 0;
  background: var(--rspoa-bg);
}

.rspoa-footer--right {
  justify-content: flex-end;
}

.rspoa-footer__spacer {
  flex: 1 1;
}

/* ---------- Buttons ---------- */
.rspoa-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.rspoa-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.rspoa-btn--sm {
  padding: 5px 12px;
  font-size: 12px;
}

.rspoa-btn--ghost {
  background: transparent;
  border-color: var(--rspoa-border-subtle);
  color: var(--rspoa-text);
}

.rspoa-btn--ghost:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.06);
  border-color: var(--rspoa-border);
}

.rspoa-btn--outline {
  background: #1a1a1a;
  border-color: var(--rspoa-border-subtle);
  color: #fff;
}

.rspoa-btn--outline:hover:not(:disabled) {
  border-color: var(--rspoa-accent);
  background: rgba(166, 27, 52, 0.15);
}

.rspoa-btn--primary {
  background: var(--rspoa-accent);
  border-color: var(--rspoa-accent);
  color: #fff;
}

.rspoa-btn--primary:hover:not(:disabled) {
  background: var(--rspoa-accent-deep);
  border-color: var(--rspoa-accent-deep);
}

.rspoa-btn--dark {
  background: #4a9eff;
  border-color: #4a9eff;
  color: #fff;
}

.rspoa-btn--dark:hover:not(:disabled) {
  background: #3b8eef;
  border-color: #3b8eef;
}

.rspoa-btn--danger {
  background: transparent;
  border-color: rgba(248, 113, 113, 0.45);
  color: var(--rspoa-danger);
}

.rspoa-btn--danger:hover:not(:disabled) {
  background: var(--rspoa-danger-bg);
}

/* ---------- Fullscreen preview ---------- */
.rspoa-fullscreen {
  position: fixed;
  inset: 0;
  z-index: 21000;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.rspoa-fullscreen img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.rspoa-fullscreen__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.rspoa-fullscreen__close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.rspoa-fullscreen__missing {
  margin: 0;
  padding: 32px 24px;
  color: #d1d5db;
  font-size: 14px;
}

.rspoa-thumb-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: var(--rspoa-text-muted);
}

/* ---------- Responsive ---------- */
@media (max-width: 680px) {
  .rspoa-body--consult {
    grid-template-columns: 1fr;
  }

  .rspoa-results {
    border-right: none;
    border-bottom: 1px solid var(--rspoa-border);
    max-height: 200px;
  }

  .rspoa-body--create {
    grid-template-columns: 1fr;
  }

  .rspoa-sidebar {
    border-right: none;
    border-bottom: 1px solid var(--rspoa-border);
    max-height: 180px;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }

  .rspoa-sidebar__cameras {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .rspoa-form-row {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RecordingsSpoaModal.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,iEAAiE;EACjE,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,iCAAiC;EACjC,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,4CAA4C;EAC5C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,iCAAiC;EACjC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ============================================================\n   Modal SPOA — mismo lenguaje visual que Grabaciones / DownloadAdvanced\n   Paleta: superficies #0a0a0a–#1a1a1a, bordes #2d2d2d / #374151, acento #a61b34\n   ============================================================ */\n\n.rspoa-modal {\n  /* tokens locales (portal en body; no heredan .recordings-page) */\n  --rspoa-bg: #111111;\n  --rspoa-bg-elevated: #1a1a1a;\n  --rspoa-bg-muted: #0a0a0a;\n  --rspoa-border: #2d2d2d;\n  --rspoa-border-subtle: #374151;\n  --rspoa-text: #e5e7eb;\n  --rspoa-text-muted: #9ca3af;\n  --rspoa-accent: #a61b34;\n  --rspoa-accent-deep: #8b1528;\n  --rspoa-focus: #a61b34;\n  --rspoa-input-bg: #252525;\n  --rspoa-danger: #f87171;\n  --rspoa-danger-bg: rgba(248, 113, 113, 0.08);\n}\n\n/* ---------- Overlay ---------- */\n.rspoa-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 20000;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n/* ---------- Modal shell ---------- */\n.rspoa-modal {\n  width: min(960px, 100%);\n  max-height: min(92vh, 820px);\n  display: flex;\n  flex-direction: column;\n  background: var(--rspoa-bg-elevated);\n  border: 1px solid var(--rspoa-border);\n  border-radius: 16px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n  color: var(--rspoa-text);\n  font-family: inherit;\n}\n\n/* ---------- Header ---------- */\n.rspoa-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--rspoa-border);\n  flex-shrink: 0;\n  background: var(--rspoa-bg);\n}\n\n.rspoa-header__title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--rspoa-text);\n}\n\n.rspoa-header__close {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--rspoa-text-muted);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.rspoa-header__close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--rspoa-text);\n}\n\n/* ---------- Search bar (Consultar view) ---------- */\n.rspoa-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--rspoa-border);\n  flex-shrink: 0;\n  background: var(--rspoa-bg);\n}\n\n.rspoa-search__input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid var(--rspoa-border-subtle);\n  border-radius: 8px;\n  font-size: 14px;\n  color: var(--rspoa-text);\n  background: var(--rspoa-input-bg);\n  outline: none;\n}\n\n.rspoa-search__input:focus {\n  border-color: var(--rspoa-focus);\n}\n\n.rspoa-search__input::placeholder {\n  color: #6b7280;\n}\n\n.rspoa-search__icon {\n  flex-shrink: 0;\n  color: var(--rspoa-text-muted);\n}\n\n/* ---------- Body ---------- */\n.rspoa-body {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* --- Consultar layout --- */\n.rspoa-body--consult {\n  display: grid;\n  grid-template-columns: minmax(200px, 0.7fr) 1fr;\n}\n\n.rspoa-results {\n  border-right: 1px solid var(--rspoa-border);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--rspoa-bg);\n}\n\n.rspoa-panel-title {\n  margin: 0;\n  padding: 12px 16px 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--rspoa-text);\n  flex-shrink: 0;\n}\n\n.rspoa-results__scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 4px 8px;\n}\n\n.rspoa-results__item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  color: var(--rspoa-text);\n  font-size: 14px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--rspoa-border);\n  transition: background 0.1s;\n}\n\n.rspoa-results__item:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.rspoa-results__item--active {\n  background: rgba(166, 27, 52, 0.18);\n  font-weight: 600;\n  color: #fff;\n}\n\n.rspoa-pruebas {\n  display: flex;\n  flex-direction: column;\n  background: var(--rspoa-bg-muted);\n  overflow: hidden;\n}\n\n.rspoa-pruebas__content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 16px 12px;\n}\n\n.rspoa-pruebas__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rspoa-prueba-card {\n  padding: 10px 12px;\n  background: var(--rspoa-bg-elevated);\n  border: 1px solid var(--rspoa-border-subtle);\n  border-radius: 8px;\n}\n\n.rspoa-prueba-card__info strong {\n  font-size: 13px;\n  color: var(--rspoa-text);\n}\n\n.rspoa-prueba-card__date {\n  display: inline-block;\n  margin-left: 10px;\n  font-size: 11px;\n  color: var(--rspoa-text-muted);\n}\n\n.rspoa-prueba-card__desc {\n  margin: 4px 0 6px;\n  font-size: 12px;\n  color: var(--rspoa-text-muted);\n  line-height: 1.4;\n}\n\n.rspoa-prueba-card__thumbs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.rspoa-prueba-card__thumb {\n  width: 48px;\n  height: 36px;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--rspoa-border-subtle);\n  background: var(--rspoa-input-bg);\n}\n\n.rspoa-prueba-card__thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.rspoa-prueba-card__more {\n  font-size: 11px;\n  color: var(--rspoa-text-muted);\n}\n\n.rspoa-pruebas__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n}\n\n.rspoa-placeholder-text {\n  margin: 0;\n  padding: 40px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--rspoa-text-muted);\n  line-height: 1.5;\n}\n\n.rspoa-muted-text {\n  margin: 0;\n  padding: 12px 16px;\n  font-size: 13px;\n  color: var(--rspoa-text-muted);\n}\n\n.rspoa-muted-text--small {\n  font-size: 12px;\n  padding: 8px 0;\n}\n\n/* --- Crear evidencia layout --- */\n.rspoa-body--create {\n  display: grid;\n  grid-template-columns: 210px 1fr;\n}\n\n.rspoa-sidebar {\n  border-right: 1px solid var(--rspoa-border);\n  padding: 16px 14px;\n  overflow-y: auto;\n  background: var(--rspoa-bg);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rspoa-sidebar__spoa-label {\n  font-size: 13px;\n  color: var(--rspoa-text);\n  line-height: 1.4;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--rspoa-border);\n}\n\n.rspoa-sidebar__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rspoa-sidebar__field label {\n  font-size: 12px;\n  color: var(--rspoa-text-muted);\n  font-weight: 500;\n}\n\n.rspoa-sidebar__field input {\n  padding: 8px 10px;\n  border: 1px solid var(--rspoa-border-subtle);\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--rspoa-text);\n  background: var(--rspoa-input-bg);\n  outline: none;\n}\n\n.rspoa-sidebar__field input:focus {\n  border-color: var(--rspoa-focus);\n}\n\n.rspoa-sidebar__cameras {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.rspoa-camera-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--rspoa-text);\n  font-size: 13px;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s, color 0.15s;\n}\n\n.rspoa-camera-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.rspoa-camera-item--active {\n  background: rgba(166, 27, 52, 0.35);\n  color: #fff;\n  box-shadow: inset 0 0 0 1px rgba(166, 27, 52, 0.5);\n}\n\n.rspoa-camera-item--active:hover {\n  background: rgba(166, 27, 52, 0.42);\n}\n\n.rspoa-camera-item__name {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rspoa-camera-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--rspoa-accent);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.rspoa-camera-item--active .rspoa-camera-badge {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* --- Content (right panel in Crear view) --- */\n.rspoa-content {\n  padding: 16px 20px;\n  overflow-y: auto;\n  background: var(--rspoa-bg-muted);\n}\n\n.rspoa-section-title {\n  margin: 0 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--rspoa-text);\n}\n\n.rspoa-error {\n  margin: 0 0 12px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: var(--rspoa-danger);\n  background: var(--rspoa-danger-bg);\n  border: 1px solid rgba(248, 113, 113, 0.25);\n  border-radius: 8px;\n}\n\n.rspoa-site-box {\n  padding: 12px 14px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid var(--rspoa-border-subtle);\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  line-height: 1.7;\n  color: var(--rspoa-text-muted);\n}\n\n.rspoa-site-box__title {\n  margin: 0 0 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--rspoa-text);\n}\n\n.rspoa-site-box p {\n  margin: 0;\n}\n\n.rspoa-site-box strong {\n  color: var(--rspoa-text);\n}\n\n.rspoa-form-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.rspoa-field {\n  margin-bottom: 16px;\n}\n\n.rspoa-field--grow {\n  flex: 1;\n  min-width: 0;\n  margin-bottom: 0;\n}\n\n.rspoa-field > label {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--rspoa-text-muted);\n  margin-bottom: 6px;\n}\n\n.rspoa-field textarea,\n.rspoa-field select,\n.rspoa-field input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border: 1px solid var(--rspoa-border-subtle);\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--rspoa-text);\n  background: var(--rspoa-input-bg);\n  outline: none;\n  resize: vertical;\n}\n\n.rspoa-field textarea:focus,\n.rspoa-field select:focus,\n.rspoa-field input:focus {\n  border-color: var(--rspoa-focus);\n}\n\n.rspoa-field select {\n  appearance: auto;\n  cursor: pointer;\n}\n\n.rspoa-field select option {\n  background: var(--rspoa-bg-elevated);\n  color: var(--rspoa-text);\n}\n\n/* --- Captures with per-photo descriptions --- */\n.rspoa-captures-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.rspoa-capture-row {\n  display: flex;\n  gap: 14px;\n  padding: 10px 12px;\n  background: var(--rspoa-bg);\n  border: 1px solid var(--rspoa-border-subtle);\n  border-radius: 8px;\n  align-items: flex-start;\n}\n\n.rspoa-capture-row__preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.rspoa-capture-row__num {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--rspoa-text-muted);\n}\n\n.rspoa-capture-row__thumb {\n  width: 110px;\n  height: 78px;\n  padding: 0;\n  border: 2px solid var(--rspoa-accent);\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--rspoa-input-bg);\n  cursor: zoom-in;\n}\n\n.rspoa-capture-row__thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.rspoa-capture-row__time {\n  font-size: 10px;\n  color: var(--rspoa-text-muted);\n  text-align: center;\n}\n\n.rspoa-capture-row__desc {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rspoa-capture-row__desc label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--rspoa-text-muted);\n}\n\n.rspoa-capture-row__desc textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border: 1px solid var(--rspoa-border-subtle);\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--rspoa-text);\n  background: var(--rspoa-input-bg);\n  outline: none;\n  resize: vertical;\n  min-height: 56px;\n}\n\n.rspoa-capture-row__desc textarea:focus {\n  border-color: var(--rspoa-focus);\n}\n\n.rspoa-capture__fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-size: 10px;\n  color: var(--rspoa-text-muted);\n  text-align: center;\n  padding: 4px;\n  box-sizing: border-box;\n}\n\n/* ---------- Footer ---------- */\n.rspoa-footer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--rspoa-border);\n  flex-shrink: 0;\n  background: var(--rspoa-bg);\n}\n\n.rspoa-footer--right {\n  justify-content: flex-end;\n}\n\n.rspoa-footer__spacer {\n  flex: 1;\n}\n\n/* ---------- Buttons ---------- */\n.rspoa-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  white-space: nowrap;\n}\n\n.rspoa-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.rspoa-btn--sm {\n  padding: 5px 12px;\n  font-size: 12px;\n}\n\n.rspoa-btn--ghost {\n  background: transparent;\n  border-color: var(--rspoa-border-subtle);\n  color: var(--rspoa-text);\n}\n\n.rspoa-btn--ghost:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: var(--rspoa-border);\n}\n\n.rspoa-btn--outline {\n  background: #1a1a1a;\n  border-color: var(--rspoa-border-subtle);\n  color: #fff;\n}\n\n.rspoa-btn--outline:hover:not(:disabled) {\n  border-color: var(--rspoa-accent);\n  background: rgba(166, 27, 52, 0.15);\n}\n\n.rspoa-btn--primary {\n  background: var(--rspoa-accent);\n  border-color: var(--rspoa-accent);\n  color: #fff;\n}\n\n.rspoa-btn--primary:hover:not(:disabled) {\n  background: var(--rspoa-accent-deep);\n  border-color: var(--rspoa-accent-deep);\n}\n\n.rspoa-btn--dark {\n  background: #4a9eff;\n  border-color: #4a9eff;\n  color: #fff;\n}\n\n.rspoa-btn--dark:hover:not(:disabled) {\n  background: #3b8eef;\n  border-color: #3b8eef;\n}\n\n.rspoa-btn--danger {\n  background: transparent;\n  border-color: rgba(248, 113, 113, 0.45);\n  color: var(--rspoa-danger);\n}\n\n.rspoa-btn--danger:hover:not(:disabled) {\n  background: var(--rspoa-danger-bg);\n}\n\n/* ---------- Fullscreen preview ---------- */\n.rspoa-fullscreen {\n  position: fixed;\n  inset: 0;\n  z-index: 21000;\n  background: rgba(0, 0, 0, 0.92);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.rspoa-fullscreen img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.rspoa-fullscreen__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.rspoa-fullscreen__close:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.rspoa-fullscreen__missing {\n  margin: 0;\n  padding: 32px 24px;\n  color: #d1d5db;\n  font-size: 14px;\n}\n\n.rspoa-thumb-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-size: 14px;\n  color: var(--rspoa-text-muted);\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 680px) {\n  .rspoa-body--consult {\n    grid-template-columns: 1fr;\n  }\n\n  .rspoa-results {\n    border-right: none;\n    border-bottom: 1px solid var(--rspoa-border);\n    max-height: 200px;\n  }\n\n  .rspoa-body--create {\n    grid-template-columns: 1fr;\n  }\n\n  .rspoa-sidebar {\n    border-right: none;\n    border-bottom: 1px solid var(--rspoa-border);\n    max-height: 180px;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .rspoa-sidebar__cameras {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .rspoa-form-row {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
